import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type SubjectTableMessages = TableColumnsMessages &
  PopoverMessages & {
    idColumn: string;
    subjectColumn: string;
  };

export const SUBJECT_TABLE_MESSAGES: SubjectTableMessages = {
  idColumn: "ID",
  subjectColumn: "Assunto",

  ...TABLE_COLUMNS_MESSAGES,
  ...POPOVER_MESSAGES,
};
